import type { TextImageProps } from "types/types";
import { resolveDatoImageLabel } from "@/lib/functions";

export function getTextImageLabel(
	data: Pick<TextImageProps, "image">
) {
	return resolveDatoImageLabel(data.image);
}

export function getTextImageLabelColor(
	data: Pick<TextImageProps, "assetLabelColor" | "textLabelColor">
) {
	return data.assetLabelColor?.color ?? data.textLabelColor?.color;
}
